import React, { useState, useEffect, useCallback, useRef } from "react";

const API_URL = "https://example.com/api/vehicles";
const UPDATE_API_URL = "https://example.com/api/vehicle/update";
const CHECK_API_URL = "https://example.com/api/check";

const UpdatedWingsData = () => {
  const initialData = [
    {
      name: "Falcon 1",
      wingsNo: "W001",
      yom: 2022,
      variant: "A",
      fuelType: "Gasoline",
    },
    {
      name: "Eagle 2",
      wingsNo: "W002",
      yom: 2023,
      variant: "B",
      fuelType: "Diesel",
    },
    {
      name: "Hawk 3",
      wingsNo: "W003",
      yom: 2024,
      variant: "C",
      fuelType: "Electric",
    },
    {
      name: "Falcon 1",
      wingsNo: "W001",
      yom: 2022,
      variant: "A",
      fuelType: "Gasoline",
    },
    {
      name: "Eagle 2",
      wingsNo: "W002",
      yom: 2023,
      variant: "B",
      fuelType: "Diesel",
    },
    {
      name: "Hawk 3",
      wingsNo: "W003",
      yom: 2024,
      variant: "C",
      fuelType: "Electric",
    },
    {
      name: "Falcon 1",
      wingsNo: "W001",
      yom: 2022,
      variant: "A",
      fuelType: "Gasoline",
    },
    {
      name: "Eagle 2",
      wingsNo: "W002",
      yom: 2023,
      variant: "B",
      fuelType: "Diesel",
    },
    {
      name: "Hawk 3",
      wingsNo: "W003",
      yom: 2024,
      variant: "C",
      fuelType: "Electric",
    },
    {
      name: "Falcon 1",
      wingsNo: "W001",
      yom: 2022,
      variant: "A",
      fuelType: "Gasoline",
    },
    {
      name: "Eagle 2",
      wingsNo: "W002",
      yom: 2023,
      variant: "B",
      fuelType: "Diesel",
    },
    {
      name: "Hawk 3",
      wingsNo: "W003",
      yom: 2024,
      variant: "C",
      fuelType: "Electric",
    },
    {
      name: "Falcon 1",
      wingsNo: "W001",
      yom: 2022,
      variant: "A",
      fuelType: "Gasoline",
    },
    {
      name: "Eagle 2",
      wingsNo: "W002",
      yom: 2023,
      variant: "B",
      fuelType: "Diesel",
    },
    {
      name: "Hawk 3",
      wingsNo: "W003",
      yom: 2024,
      variant: "C",
      fuelType: "Electric",
    },
    {
      name: "Falcon 1",
      wingsNo: "W001",
      yom: 2022,
      variant: "A",
      fuelType: "Gasoline",
    },
    {
      name: "Eagle 2",
      wingsNo: "W002",
      yom: 2023,
      variant: "B",
      fuelType: "Diesel",
    },
    {
      name: "Hawk 3",
      wingsNo: "W003",
      yom: 2024,
      variant: "C",
      fuelType: "Electric",
    },
    {
      name: "Falcon 1",
      wingsNo: "W001",
      yom: 2022,
      variant: "A",
      fuelType: "Gasoline",
    },
    {
      name: "Eagle 2",
      wingsNo: "W002",
      yom: 2023,
      variant: "B",
      fuelType: "Diesel",
    },
    {
      name: "Hawk 3",
      wingsNo: "W003",
      yom: 2024,
      variant: "C",
      fuelType: "Electric",
    },
    {
      name: "Falcon 1",
      wingsNo: "W001",
      yom: 2022,
      variant: "A",
      fuelType: "Gasoline",
    },
    {
      name: "Eagle 2",
      wingsNo: "W002",
      yom: 2023,
      variant: "B",
      fuelType: "Diesel",
    },
    {
      name: "Hawk 3",
      wingsNo: "W003",
      yom: 2024,
      variant: "C",
      fuelType: "Electric",
    },
    {
      name: "Falcon 1",
      wingsNo: "W001",
      yom: 2022,
      variant: "A",
      fuelType: "Gasoline",
    },
    {
      name: "Eagle 2",
      wingsNo: "W002",
      yom: 2023,
      variant: "B",
      fuelType: "Diesel",
    },
    {
      name: "Hawk 3",
      wingsNo: "W003",
      yom: 2024,
      variant: "C",
      fuelType: "Electric",
    },
    {
      name: "Falcon 1",
      wingsNo: "W001",
      yom: 2022,
      variant: "A",
      fuelType: "Gasoline",
    },
    {
      name: "Eagle 2",
      wingsNo: "W002",
      yom: 2023,
      variant: "B",
      fuelType: "Diesel",
    },
    {
      name: "Hawk 3",
      wingsNo: "W003",
      yom: 2024,
      variant: "C",
      fuelType: "Electric",
    },
    {
      name: "Falcon 1",
      wingsNo: "W001",
      yom: 2022,
      variant: "A",
      fuelType: "Gasoline",
    },
    {
      name: "Eagle 2",
      wingsNo: "W002",
      yom: 2023,
      variant: "B",
      fuelType: "Diesel",
    },
    {
      name: "Hawk 3",
      wingsNo: "W003",
      yom: 2024,
      variant: "C",
      fuelType: "Electric",
    },
    {
      name: "Falcon 1",
      wingsNo: "W001",
      yom: 2022,
      variant: "A",
      fuelType: "Gasoline",
    },
    {
      name: "Eagle 2",
      wingsNo: "W002",
      yom: 2023,
      variant: "B",
      fuelType: "Diesel",
    },
    {
      name: "Hawk 3",
      wingsNo: "W003",
      yom: 2024,
      variant: "C",
      fuelType: "Electric",
    },
    {
      name: "Falcon 1",
      wingsNo: "W001",
      yom: 2022,
      variant: "A",
      fuelType: "Gasoline",
    },
    {
      name: "Eagle 2",
      wingsNo: "W002",
      yom: 2023,
      variant: "B",
      fuelType: "Diesel",
    },
    {
      name: "Hawk 3",
      wingsNo: "W003",
      yom: 2024,
      variant: "C",
      fuelType: "Electric",
    },
    {
      name: "Falcon 1",
      wingsNo: "W001",
      yom: 2022,
      variant: "A",
      fuelType: "Gasoline",
    },
    {
      name: "Eagle 2",
      wingsNo: "W002",
      yom: 2023,
      variant: "B",
      fuelType: "Diesel",
    },
    {
      name: "Hawk 3",
      wingsNo: "W003",
      yom: 2024,
      variant: "C",
      fuelType: "Electric",
    },
    {
      name: "Falcon 1",
      wingsNo: "W001",
      yom: 2022,
      variant: "A",
      fuelType: "Gasoline",
    },
    {
      name: "Eagle 2",
      wingsNo: "W002",
      yom: 2023,
      variant: "B",
      fuelType: "Diesel",
    },
    {
      name: "Hawk 3",
      wingsNo: "W003",
      yom: 2024,
      variant: "C",
      fuelType: "Electric",
    },
    {
      name: "Falcon 1",
      wingsNo: "W001",
      yom: 2022,
      variant: "A",
      fuelType: "Gasoline",
    },
    {
      name: "Eagle 2",
      wingsNo: "W002",
      yom: 2023,
      variant: "B",
      fuelType: "Diesel",
    },
    {
      name: "Hawk 3",
      wingsNo: "W003",
      yom: 2024,
      variant: "C",
      fuelType: "Electric",
    },
  ];

  const [tableData, setTableData] = useState(initialData);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(true); // New state for showing the modal
  const [hasMore, setHasMore] = useState(true); // To control if there is more data to load
  const [page, setPage] = useState(1); // Track the current page for pagination

  const tableContainerRef = useRef(null); // Create a ref for the table container

  // Fetch data from API
  const fetchData = async (page) => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}?page=${page}`);
      const data = await response.json();

      // If the fetched data is empty, set `hasMore` to false
      if (data.length === 0) {
        setHasMore(false);
      }

      // Append new data to the existing data
      setTableData((prevData) => [...prevData, ...data]);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch the first page of data on mount
  useEffect(() => {
    fetchData(page);
  }, [page]); // This effect runs whenever the page changes

  // Fetch data to determine whether to show the modal
  useEffect(() => {
    const checkModalData = async () => {
      try {
        const response = await fetch(CHECK_API_URL);
        const data = await response.json();

        // If data exists, show the modal
        if (data && data.length > 0) {
          setShowModal(true);
        } else {
          setShowModal(false);
        }
      } catch (error) {
        console.error("Error fetching check data:", error);
      }
    };

    checkModalData();
  }, []); // Empty dependency array to check only once when the component is mounted

  const handleInputChange = (index, field, value) => {
    const updatedData = [...tableData];
    updatedData[index][field] = value;
    setTableData(updatedData);
  };

  const handleUpdateRow = async (index) => {
    const updatedRow = tableData[index];

    // Skip update if any required fields are empty
    if (!updatedRow.yom || !updatedRow.variant || !updatedRow.fuelType) return;

    try {
      const response = await fetch(`${UPDATE_API_URL}/${updatedRow.wingsNo}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedRow),
      });

      if (response.ok) {
        // Optionally update the state or give feedback
      } else {
        // Handle error response
      }
    } catch (error) {
      console.error("Error updating row:", error);
    }
  };

  const handleUpdateAll = async () => {
    // Ensure that all rows have required fields filled
    const allRowsValid = tableData.every(
      (row) => row.yom && row.variant && row.fuelType
    );

    if (!allRowsValid) return; // Prevent submission if any row has empty fields

    try {
      const response = await fetch(UPDATE_API_URL, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(tableData),
      });

      if (response.ok) {
        // Optionally update the state or give feedback
      } else {
        // Handle error response
      }
    } catch (error) {
      console.error("Error updating all rows:", error);
    }
  };

  const currentYear = new Date().getFullYear();

  const generateYears = (start, count) => {
    const years = [];
    for (let i = 0; i < count; i++) {
      years.push(start + i);
    }
    return years;
  };

  // Check if all required fields are filled for a row
  const isRowValid = (row) => row.yom && row.variant && row.fuelType;

  // Check if all rows have valid fields
  const isFormValid = tableData.every(isRowValid);

  // Function to handle scroll event for infinite scrolling
  const handleScroll = useCallback(
    (e) => {
      const bottom =
        e.target.scrollHeight === e.target.scrollTop + e.target.clientHeight;

      if (bottom && hasMore && !loading) {
        setPage((prevPage) => prevPage + 1); // Increment the page to fetch next chunk
      }
    },
    [hasMore, loading]
  );

  useEffect(() => {
    const tableElement = tableContainerRef.current;
    if (tableElement) {
      tableElement.addEventListener("scroll", handleScroll);
    }

    // Cleanup event listener on component unmount
    return () => {
      if (tableElement) {
        tableElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);

  if (loading && page === 1) {
    return <div>Loading...</div>;
  }

  return (
    <>
      {/* Modal */}
      {showModal && (
        <div className="modal-overlay fixed h-full inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center">
          <div className="modal-content bg-white p-6 rounded-lg max-w-6xl w-full">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              Vehicle Data Table
            </h2>
            <div ref={tableContainerRef} className="overflow-y-auto max-h-96">
              <table className="table-auto w-full border-collapse border border-gray-300 rounded-lg overflow-hidden">
                <thead>
                  <tr className="bg-blue-600 text-white">
                    <th className="border border-gray-300 p-4 text-left">
                      Wings No.
                    </th>
                    <th className="border border-gray-300 p-4 text-left">
                      YOM
                    </th>
                    <th className="border border-gray-300 p-4 text-left">
                      Variant
                    </th>
                    <th className="border border-gray-300 p-4 text-left">
                      Fuel Type
                    </th>
                    <th className="border border-gray-300 p-4 text-left">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, index) => (
                    <tr
                      key={index}
                      className="hover:bg-gray-100 transition-all duration-200 ease-in-out"
                    >
                      <td className="border-2 border-gray-300 p-4">
                        {row.wingsNo}
                      </td>
                      <td className="border-2 border-gray-300 p-4">
                        <select
                          value={row.yom}
                          onChange={(e) =>
                            handleInputChange(index, "yom", e.target.value)
                          }
                          className={`w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                            !row.yom && "border-red-500"
                          }`}
                        >
                          {generateYears(currentYear - 2, 12).map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td className="border-2 border-gray-300 p-4">
                        <input
                          type="text"
                          value={row.variant}
                          onChange={(e) =>
                            handleInputChange(index, "variant", e.target.value)
                          }
                          className={`w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                            !row.variant && "border-red-500"
                          }`}
                          placeholder="Enter variant"
                        />
                      </td>
                      <td className="border-2 border-gray-300 p-4">
                        <input
                          type="text"
                          value={row.fuelType}
                          onChange={(e) =>
                            handleInputChange(index, "fuelType", e.target.value)
                          }
                          className={`w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                            !row.fuelType && "border-red-500"
                          }`}
                          placeholder="Enter fuel type"
                        />
                      </td>
                      <td className="border-2 border-gray-300 p-4">
                        <button
                          className={`bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                            !isRowValid(row) && "opacity-50 cursor-not-allowed"
                          }`}
                          onClick={() => handleUpdateRow(index)}
                          disabled={!isRowValid(row)}
                        >
                          Update
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="mt-6 flex items-center justify-end">
              <button
                className={`bg-green-500 text-white px-6 py-3 rounded-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 ${
                  !isFormValid && "opacity-50 cursor-not-allowed"
                }`}
                onClick={handleUpdateAll}
                disabled={!isFormValid}
              >
                Update All
              </button>
            </div>
            <button
              className="mt-4 bg-red-500 text-white px-4 py-2 rounded-lg"
              onClick={() => setShowModal(false)} // Close the modal
            >
              Close Modal
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default UpdatedWingsData;
